// 개발 중에도 console.log/info/debug 는 기본으로 끈다 (warn/error 는 그대로).
// 로그가 필요하면 브라우저 콘솔에서 localStorage.debug = '1' 입력 후 새로고침. 운영 빌드는 vue.config.js 가 log 호출 자체를 지운다
if (process.env.NODE_ENV !== 'production') {
    let debugLog = false;
    try {
        debugLog = localStorage.getItem('debug') === '1';
    } catch (e) {
        // 저장소에 접근할 수 없으면 끈 상태 유지
    }
    if (!debugLog) {
        console.log = () => {};
        console.info = () => {};
        console.debug = () => {};
    }
}

// 🔥 www → non-www 리다이렉트 (최상단에서 즉시 실행)
if (window.location.hostname === 'www.mytoolb2b.link') {
    window.location.replace('https://mytoolb2b.link' + window.location.pathname + window.location.search);
}

import { createApp } from 'vue/dist/vue.esm-bundler.js';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import { getStoreConfig } from './services/storeConfigService';

import './assets/styles/global.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Chart.js import 추가
import 'chart.js/auto';

// AG Grid
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import 'ag-grid-community/styles/ag-theme-balham.css';

import { ModuleRegistry, AllCommunityModule, provideGlobalGridOptions } from 'ag-grid-community';
// AG Grid 33부터는 쓰는 기능을 모듈로 등록해야 동작한다. 예전에는 행 모델·페이지만 등록해서
// 행 선택(체크박스)·칼럼 필터·툴팁 등이 화면에서 조용히 빠져 있었다 → 커뮤니티 모듈 전체 등록.
ModuleRegistry.registerModules([AllCommunityModule]);
// 테마는 33 기본(JS 테마)을 그대로 쓴다. 위 CSS 파일 import 는 패키지 sideEffects:false 때문에 빌드에서 빠지므로
// theme: 'legacy' 로 바꾸면 스타일이 하나도 없어져 그리드가 깨진다(2026-10-14 확인).
// 화면 30곳이 gridApi.sizeColumnsToFit() 을 부르는데, 모듈이 없던 때는 조용히 실패해 아무 일도 안 했다.
// 모듈을 등록하자 실제로 동작해 칼럼이 많은 화면(주문·제품 목록)의 칸이 최소 너비까지 눌렸다 → 예전처럼 맞추지 않게 모든 칸에서 제외.
// ('deep' 이라 화면마다 둔 defaultColDef 와 합쳐진다. 칸을 화면 폭에 맞추고 싶으면 flex 를 쓸 것)
// 헤더의 필터 아이콘도 모듈 등록 전에는 보이지 않았으므로 원래 모양대로 숨긴다(화면마다 filter: true 가 남아 있음).
provideGlobalGridOptions({ defaultColDef: { suppressSizeToFit: true, suppressHeaderFilterButton: true } }, 'deep');

// 스타일
import './assets/styles/shop.css';
import './assets/styles/admin.css';

// 🔥 이미지 헬퍼 import
import { getImageUrl, getDefaultImage, handleImageError, setupImageErrorHandling } from '@/utils/imageHelper.js';

// 예전 관리자 로그인은 관리자 토큰을 회원 자리(auth_token)에도 저장했다.
// 그 브라우저에 남은 관리자 토큰을 회원 토큰으로 오인하지 않도록 한 번 정리한다.
[localStorage, sessionStorage].forEach(storage => {
    const memberToken = storage.getItem('auth_token');
    if (memberToken && memberToken === (localStorage.getItem('adminToken') || sessionStorage.getItem('adminToken'))) {
        storage.removeItem('auth_token');
    }
});

const app = createApp(App);

// 🔥 글로벌 이미지 처리 함수들
app.config.globalProperties.$getImageUrl = getImageUrl;
app.config.globalProperties.$getDefaultImage = getDefaultImage;
app.config.globalProperties.$handleImageError = handleImageError;
app.config.globalProperties.$getUploadUrl = getUploadUrl;

// 🔥 자동 이미지 오류 처리 설정
app.config.globalProperties.$setupImageErrorHandling = setupImageErrorHandling;

// API URL 폴백 설정 함수
function getApiBaseUrl() {
    const hostname = window.location.hostname;
    const port = window.location.port;
    const isAdminPage = window.location.pathname.startsWith('/admin');

    console.log('🌐 현재 호스트:', hostname, '포트:', port, '관리자페이지:', isAdminPage);

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        console.log('🔧 로컬 개발 환경 감지');
        return 'http://localhost:8080';
    } else if (hostname === '13.125.54.204') {
        console.log('🚀 EC2 IP 직접 접속 감지');
        return 'http://13.125.54.204:8080';
    } else if (hostname.includes('mytoolb2b.link')) {
        console.log('🌍 도메인 환경 감지 - mytoolb2b.link');

        if (process.env.NODE_ENV === 'production') {
            console.log('🚀 프로덕션 환경 - HTTPS API 사용');
            return 'https://mytoolb2b.link';
        } else {
            console.log('🔧 개발 환경 - 폴백 API 사용');
            return process.env.VUE_APP_FALLBACK_API_URL || 'http://13.125.54.204:8080';
        }
    } else {
        console.log('❓ 기타 환경 감지, 폴백 API 사용');
        return process.env.VUE_APP_FALLBACK_API_URL || 'http://13.125.54.204:8080';
    }
}

// 🔥 글로벌 업로드 URL 생성 함수 추가 (기존 함수 유지)
function getUploadUrl(endpoint = '/api/admin/upload') {
    const baseUrl = getApiBaseUrl();
    return `${baseUrl}${endpoint}`;
}

// axios 기본 설정
const apiBaseUrl = getApiBaseUrl();
axios.defaults.baseURL = apiBaseUrl;
axios.defaults.headers.common['Content-Type'] = 'application/json';

console.log('✅ API Base URL 설정:', apiBaseUrl);

// 🔥 요청 인터셉터
axios.interceptors.request.use(
    (config) => {
        const isAdminPage = window.location.pathname.startsWith('/admin');

        let token = null;
        if (isAdminPage) {
            token = localStorage.getItem('adminToken') || sessionStorage.getItem('adminToken');
            if (!token) {
                const userToken = localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token');
                if (userToken) {
                    console.log('🚨 일반 사용자 토큰이 있지만 관리자 페이지에서 무시됨');
                }
            }
        } else {
            token = localStorage.getItem('auth_token') || sessionStorage.getItem('auth_token');
            if (!token) {
                const adminToken = localStorage.getItem('adminToken') || sessionStorage.getItem('adminToken');
                if (adminToken) {
                    console.log('🚨 관리자 토큰이 있지만 일반 페이지에서 무시됨');
                }
            }
        }

        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        console.error('🔥 요청 인터셉터 오류:', error);
        return Promise.reject(error);
    }
);

// 🔥 응답 인터셉터 (401 에러 처리)
// 401 처리: 토큰·저장된 사용자 정보를 지우고 로그인 화면으로 보낸 뒤 서버가 알려준 사유를 1번만 안내한다.
// 서버 사유 코드: UNAUTHORIZED(토큰 없음), TOKEN_INVALID(만료·위조), ACCOUNT_INACTIVE(정지·승인 대기)
// 동시에 여러 요청이 401 을 받아도 안내는 한 번만 (handlingUnauthorized).
let handlingUnauthorized = false;

function handleUnauthorized(body) {
    if (handlingUnauthorized) return;

    const isAdminPage = window.location.pathname.startsWith('/admin');
    const loginPath = isAdminPage ? '/admin/login' : '/login';

    if (isAdminPage) {
        ['adminToken', 'adminUser'].forEach(key => {
            localStorage.removeItem(key);
            sessionStorage.removeItem(key);
        });
    } else {
        ['auth_token', 'user_info'].forEach(key => {
            localStorage.removeItem(key);
            sessionStorage.removeItem(key);
        });
    }

    // 로그인 화면 자체(예: 관리자 로그인 비밀번호 오류 401)에서는 안내·이동하지 않는다
    if (router.currentRoute.value.path === loginPath) return;

    handlingUnauthorized = true;
    const message = (body && body.message) || '로그인이 필요합니다. 다시 로그인해주세요.';
    // 먼저 이동해 이전 화면(로그인 상태 표시)이 남지 않게 한 뒤 안내
    router.push(loginPath).finally(() => {
        alert(message);
        handlingUnauthorized = false;
    });
}

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        console.error('🔥 API 응답 오류:', error.response?.status, error.response?.data);

        if (error.response && error.response.status === 401) {
            handleUnauthorized(error.response.data);
        }

        return Promise.reject(error);
    }
);

// �� 모든 이미지 URL을 자동으로 변환하는 함수 추가 (위로 이동)
function transformAllImageUrls() {
    const images = document.querySelectorAll('img');
    const apiBaseUrl = getApiBaseUrl();

    images.forEach(img => {
        if (img.src && !img.src.startsWith('data:') && !img.src.startsWith('blob:')) {
            // localhost:8080을 운영서버 URL로 변환
            if (img.src.includes('localhost:8080')) {
                const newSrc = img.src.replace('http://localhost:8080', apiBaseUrl);
                img.src = newSrc;
                console.log('🔄 이미지 URL 변환:', img.src, '→', newSrc);
            }
        }
    });
}

// 🔥 페이지 이동 시 이미지 오류 처리 재설정
router.afterEach(() => {
    setTimeout(() => {
        // 스크롤 초기화
        window.scrollTo({ top: 0, behavior: 'auto' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        if (window.pageYOffset !== undefined) {
            window.pageYOffset = 0;
        }

        // 🔥 이미지 오류 처리 재설정
        setupImageErrorHandling();
        transformAllImageUrls();

        // 🔥 페이지 제목 업데이트
        updatePageTitle();
    }, 150);
});

// 🔥 사이트 제목 로드 및 업데이트 함수
async function loadSiteTitle() {
    try {
        // 라우트 이동마다 호출되므로 공용 서비스로 받은 값을 재사용
        const store = await getStoreConfig();
        if (store && store.name) {
            document.title = store.name;
        } else {
            console.log('⚠️ 사이트 제목이 설정되지 않음, 기본값 사용');
            document.title = '마이툴 - 공구 쇼핑몰';
        }
    } catch (error) {
        console.error('❌ 사이트 제목 로드 실패:', error);
        document.title = '마이툴 - 공구 쇼핑몰';
    }
}

// 🔥 페이지별 제목 업데이트 함수
function updatePageTitle() {
    const currentPath = router.currentRoute.value.path;

    // 관리자 페이지인 경우
    if (currentPath.startsWith('/admin')) {
        loadSiteTitle().then(() => {
            const currentTitle = document.title;
            document.title = `관리자 - ${currentTitle}`;
        });
    } else {
        // 일반 사용자 페이지
        loadSiteTitle();
    }
}

app.config.globalProperties.$axios = axios;

app.use(router);
app.use(store);

// 🔥 앱 마운트 후 이미지 오류 처리 설정
app.mount('#app');

// 🔥 DOM 로드 완료 후 자동 이미지 오류 처리 시작
document.addEventListener('DOMContentLoaded', () => {
    setupImageErrorHandling();
});

// 🔥 즉시 실행 (이미 DOM이 로드된 경우)
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        setupImageErrorHandling();
        transformAllImageUrls(); // 여기도 추가
    });
} else {
    setupImageErrorHandling();
    transformAllImageUrls(); // 여기도 추가
}